module.exports = __webpack_public_path__ + "static/media/Richardson,Des.ab754b8a.png";